<template>
  <div id="page-home">
    <ContentHeader is-homepage :image="$wp.header.image">
      <h1 class="header__title">{{ $wp.header.title }}</h1>

      <h3 class="header__subtitle">
        <span class="header__subtitle-text">
          <Icon id="chat" class="header__subtitle-icon" />
          {{ $wp.header.content }}
        </span>
      </h3>
      <PageLink v-bind="$wp.header.link" class="button -corner" />
    </ContentHeader>

    <ContentSection :title="$wp.discover.title" alt-background class="-push">
      <ul class="row -spread discovery">
        <li v-for="item in $wp.discover.items_items" :key="item.title" class="discovery__item">
          <figure class="discovery__image" :style="{ backgroundImage: `url(${item.image})` }" />
          <h4 class="discovery__title">{{ item.title }}</h4>
          <ContentRaw :html="item.content" />
          <PageLink v-if="item.link" v-bind="item.link" class="discovery__link" />
        </li>
      </ul>
    </ContentSection>

    <ContentSection :title="$wp.latestNews.title">
      <div class="row -center -wrap">
        <article v-for="article in latestNews" :key="article.id" class="card -article">
          <figure v-if="article.image" class="card__image" :style="{ backgroundImage: `url(${article.image})` }" />

          <div class="card__content">
            <div>
              <h5 class="card__title">{{ article.title }}</h5>
              <time class="card__caption">{{ article.published }}</time>
            </div>

            <RouterLink :to="getArticleLink(article)" class="card__link">{{ viewArticleLabel }}</RouterLink>
          </div>
        </article>

        <RouterLink :to="$lang.route({ name: 'news' })" class="button">{{ allNewsLabel }}</RouterLink>
      </div>
    </ContentSection>

    <ContentSection alt-background class="-promo">
      <div class="row -spread">
        <div class="row__item -span-5">
          <div class="card__content -home-vitrine">
            <h2 class="section__title -align-left -flat">
              <span class="section__title-underline">{{ $wp.promo.title }}</span>
            </h2>
            <h5 class="card__title">{{ $wp.promo.subtitle }}</h5>
            <p>{{ $wp.promo.text }}</p>
            <div class="card__buttons">
              <a :href="$wp.promo.url1" rel="noopener" target="_blank" class="button card__button">{{
                $wp.promo.linkLabel1
              }}</a>
              <a :href="$wp.promo.url2" rel="noopener" target="_blank" class="button card__button">{{
                $wp.promo.linkLabel2
              }}</a>
            </div>
          </div>
        </div>
        <figure class="row__item -span-6 -align-right">
          <img class="card__image -top-neg" :src="$wp.promo.image" />
        </figure>
      </div>
    </ContentSection>

    <ContentSection :title="$wp.contact.title">
      <div class="row -center -wrap">
        <article v-for="(item, index) in $wp.contact.items" :key="item.title" class="card">
          <figure class="card__image" :style="{ backgroundImage: `url(${item.image})` }" />

          <div class="card__content">
            <div>
              <h5 class="card__title">{{ item.title }}</h5>
              <p>{{ item.text }}</p>
              <RouterLink :to="getContactLink(index)" class="button -corner card__button"
                >{{ contactLabel }}
              </RouterLink>
            </div>
          </div>
        </article>
      </div>
    </ContentSection>

    <ContentSection alt-background content-class="row -align-end -spread">
      <ContentRaw :html="mandate.content" class="row__item -span-7">
        <ContentTitle align-left>{{ mandate.title }}</ContentTitle>
      </ContentRaw>

      <figure class="row__item -span-4 raw-html -align-right">
        <img class="quebec-logo" :src="mandate.logo" />
        <figcaption>{{ mandate.caption }}</figcaption>
      </figure>
    </ContentSection>

    <CTAModal :content="$wp.announcement" />
  </div>
</template>

<script>
import { ContentHeader, ContentRaw, ContentSection, ContentTitle } from '@/components/content'
import { CTAModal } from '@/components/partials'

export default {
  name: 'Home',
  contentKey: 'home',
  components: { CTAModal, ContentSection, ContentRaw, ContentTitle, ContentHeader },
  computed: {
    latestNews() {
      return Object.values(this.$store.state.collections.articles).slice(0, 4)
    },
    allNewsLabel() {
      return this.$lang.current === 'en' ? 'See all news' : 'Voir toutes les nouvelles'
    },
    mandate() {
      return this.$wp.contact.mandate
    },
    viewArticleLabel() {
      return this.$lang.current === 'en' ? 'Read this news' : 'Lire cette nouvelle'
    },
    contactLabel() {
      return this.$lang.current === 'en' ? 'Contact us' : 'Écrivez-nous'
    }
  },
  methods: {
    getArticleLink({ slug, categories }) {
      const [categoryId] = categories || []
      const category = categoryId
        ? this.$store.getters.currentNewsCategories[categoryId].slug[this.$lang.current]
        : 'all'

      return this.$lang.route({ name: 'article', params: { category, articleSlug: slug } })
    },
    getContactLink(option) {
      return this.$store.getters.overlayLink('contact', { option })
    }
  }
}
</script>
